import { ConsolidationRuleDTO } from "./consolidationRuleDTO";

export class ConsolidationDefinitionDTO{

    public id!: number;
    public name!: string;
    public description!: string;
    public fileDefinitionId!: number;
    public consolidationFieldReferences!: string;
    public consolidationRules!: ConsolidationRuleDTO[];
    public sortFieldReferences!: string;
    public sortDesc!: boolean;
    public version!: number; //incremental version number set by server
    public published!: boolean; //if true, then can be used for moovs and can be loaded by other users
    public added!: string;
    public deleted!: boolean;
    public ownedByEntityId!: number;
    public ownerEntityType!: string;


    constructor(){
        this.consolidationRules = new Array();
    }
}